import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const styles: StyleRulesCallback = ({ spacing: { unit }, palette }) => ({
  main: {
    backgroundColor: palette.common.white,
    height: unit / 2
  }
});

type IProps = WithStyles<typeof styles>;

const BarBase: React.FC<IProps> = ({ classes, children }) => (
  <div className={classes.main}>{children}</div>
);

const Bar = withStyles(styles)(BarBase);

export { Bar };
